import React from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { Button } from "@similarweb/ui-components";
import { AssetsService } from "app/services/AssetsService";
import { hasCrmPermissions } from "app/components/SideBar/utils";
import { crmIntegrationStatusSyncConfig } from "./inactiveCrmIntegrationConfig";
import { StyledCrmIntegratedDescription } from "../styles";
import { StyledCrmIntegratedTitle, StyledInactiveCrmIntegration, StyledImageContainer } from "./styles";
import type { CrmSyncStatusName } from "../types";

type InactiveCrmIntegrationProps = {
    crmSyncStatusName: CrmSyncStatusName;
};

export const InactiveCrmIntegration = ({ crmSyncStatusName }: InactiveCrmIntegrationProps) => {
    const levelPermission = hasCrmPermissions() ? "admin" : "user";

    const {
        title,
        imageName,
        [levelPermission]: levelPermissionConfig,
    } = crmIntegrationStatusSyncConfig[crmSyncStatusName];

    const { linkTo, btnLabel, description } = levelPermissionConfig;

    const onClick = () => proNavigator.go(linkTo);

    return (
        <StyledInactiveCrmIntegration>
            <StyledImageContainer>
                <img
                    alt="picture integration"
                    src={AssetsService.assetUrl(imageName)}
                />
            </StyledImageContainer>
            <div>
                {title && <StyledCrmIntegratedTitle>{title}</StyledCrmIntegratedTitle>}
                <StyledCrmIntegratedDescription dangerouslySetInnerHTML={{ __html: description }} />
                {linkTo && <Button onClick={onClick}>{btnLabel}</Button>}
            </div>
        </StyledInactiveCrmIntegration>
    );
};
